'use client';

import React from 'react';

export const UsaIcon = () => {
  return (
    <svg
      className="rounded-[2px]"
      width="16"
      height="12"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H24V18H0V0Z"
        fill="#F7FCFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11V12.5H24V11H0Z"
        fill="#E31D1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 13.75V15.25H24V13.75H0Z"
        fill="#E31D1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 5.5V7H24V5.5H0Z"
        fill="#E31D1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 16.5V18H24V16.5H0Z"
        fill="#E31D1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8.25V9.75H24V8.25H0Z"
        fill="#E31D1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V1.5H24V0H0Z"
        fill="#E31D1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2.75V4.25H24V2.75H0Z"
        fill="#E31D1C"
      />
      <rect width="15" height="9.75" fill="#2E42A5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.29154 2.20415L3.74713 2.58582L3.93093 1.90661L3.44739 1.47618H4.07895L4.29078 0.921875L4.53915 1.47618H5.07755L4.65452 1.90661L4.81829 2.58582L4.29154 2.20415ZM1.29155 2.20427L0.747142 2.58594L0.93094 1.90673L0.447403 1.4763H1.07897L1.29079 0.921997L1.53917 1.4763H2.07756L1.65453 1.90673L1.8183 2.58594L1.29155 2.20427ZM6.74713 2.58582L7.29154 2.20415L7.81829 2.58582L7.65452 1.90661L8.07755 1.47618H7.53915L7.29078 0.921875L7.07895 1.47618H6.44739L6.93092 1.90661L6.74713 2.58582ZM10.2915 2.20415L9.74713 2.58582L9.93093 1.90661L9.44739 1.47618H10.079L10.2908 0.921875L10.5392 1.47618H11.0775L10.6545 1.90661L10.8183 2.58582L10.2915 2.20415ZM0.747126 5.58582L1.29154 5.20415L1.81829 5.58582L1.65452 4.90661L2.07755 4.47618H1.53915L1.29078 3.92188L1.07895 4.47618H0.447388L0.930925 4.90661L0.747126 5.58582ZM4.29154 5.20415L3.74713 5.58582L3.93093 4.90661L3.44739 4.47618H4.07895L4.29078 3.92188L4.53915 4.47618H5.07755L4.65452 4.90661L4.81829 5.58582L4.29154 5.20415ZM6.74713 5.58582L7.29154 5.20415L7.81829 5.58582L7.65452 4.90661L8.07755 4.47618H7.53915L7.29078 3.92188L7.07895 4.47618H6.44739L6.93092 4.90661L6.74713 5.58582ZM10.2915 5.20415L9.74713 5.58582L9.93093 4.90661L9.44739 4.47618H10.079L10.2908 3.92188L10.5392 4.47618H11.0775L10.6545 4.90661L10.8183 5.58582L10.2915 5.20415ZM0.747126 8.58582L1.29154 8.20415L1.81829 8.58582L1.65452 7.90661L2.07755 7.47618H1.53915L1.29078 6.92188L1.07895 7.47618H0.447388L0.930925 7.90661L0.747126 8.58582ZM4.29154 8.20415L3.74713 8.58582L3.93093 7.90661L3.44739 7.47618H4.07895L4.29078 6.92188L4.53915 7.47618H5.07755L4.65452 7.90661L4.81829 8.58582L4.29154 8.20415ZM6.74713 8.58582L7.29154 8.20415L7.81829 8.58582L7.65452 7.90661L8.07755 7.47618H7.53915L7.29078 6.92188L7.07895 7.47618H6.44739L6.93092 7.90661L6.74713 8.58582ZM10.2915 8.20415L9.74713 8.58582L9.93093 7.90661L9.44739 7.47618H10.079L10.2908 6.92188L10.5392 7.47618H11.0775L10.6545 7.90661L10.8183 8.58582L10.2915 8.20415ZM12.7471 2.58582L13.2915 2.20415L13.8183 2.58582L13.6545 1.90661L14.0775 1.47618H13.5392L13.2908 0.921875L13.079 1.47618H12.4474L12.9309 1.90661L12.7471 2.58582ZM13.2915 5.20415L12.7471 5.58582L12.9309 4.90661L12.4474 4.47618H13.079L13.2908 3.92188L13.5392 4.47618H14.0775L13.6545 4.90661L13.8183 5.58582L13.2915 5.20415ZM12.7471 8.58582L13.2915 8.20415L13.8183 8.58582L13.6545 7.90661L14.0775 7.47618H13.5392L13.2908 6.92188L13.079 7.47618H12.4474L12.9309 7.90661L12.7471 8.58582ZM2.79154 3.70415L2.24713 4.08582L2.43093 3.40661L1.94739 2.97618H2.57895L2.79078 2.42188L3.03915 2.97618H3.57755L3.15452 3.40661L3.31829 4.08582L2.79154 3.70415ZM5.24713 4.08582L5.79154 3.70415L6.31829 4.08582L6.15452 3.40661L6.57755 2.97618H6.03915L5.79078 2.42188L5.57895 2.97618H4.94739L5.43092 3.40661L5.24713 4.08582ZM8.79154 3.70415L8.24713 4.08582L8.43092 3.40661L7.94739 2.97618H8.57895L8.79078 2.42188L9.03915 2.97618H9.57755L9.15452 3.40661L9.31829 4.08582L8.79154 3.70415ZM2.24713 7.08582L2.79154 6.70415L3.31829 7.08582L3.15452 6.40661L3.57755 5.97618H3.03915L2.79078 5.42188L2.57895 5.97618H1.94739L2.43093 6.40661L2.24713 7.08582ZM5.79154 6.70415L5.24713 7.08582L5.43092 6.40661L4.94739 5.97618H5.57895L5.79078 5.42188L6.03915 5.97618H6.57755L6.15452 6.40661L6.31829 7.08582L5.79154 6.70415ZM8.24713 7.08582L8.79154 6.70415L9.31829 7.08582L9.15452 6.40661L9.57755 5.97618H9.03915L8.79078 5.42188L8.57895 5.97618H7.94739L8.43092 6.40661L8.24713 7.08582ZM11.7915 3.70415L11.2471 4.08582L11.4309 3.40661L10.9474 2.97618H11.579L11.7908 2.42188L12.0392 2.97618H12.5775L12.1545 3.40661L12.3183 4.08582L11.7915 3.70415ZM11.2471 7.08582L11.7915 6.70415L12.3183 7.08582L12.1545 6.40661L12.5775 5.97618H12.0392L11.7908 5.42188L11.579 5.97618H10.9474L11.4309 6.40661L11.2471 7.08582Z"
        fill="#F7FCFF"
      />
    </svg>
  );
};

export const KoreaIcon = () => {
  return (
    <svg
      className="rounded-[2px]"
      width="16"
      height="12"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2701_36645)">
        <rect width="24" height="18" rx="3" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V18H24V0H0Z"
          fill="#EBEDEE"
        />
        <mask
          id="mask0_2701_36645"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="18">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V18H24V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_2701_36645)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 13.6655C14.402 13.6655 16.3493 11.5976 16.3493 9.04664C16.3493 6.49569 14.402 4.42773 12 4.42773C9.59794 4.42773 7.6507 6.49569 7.6507 9.04664C7.6507 11.5976 9.59794 13.6655 12 13.6655Z"
            fill="#3D58DB"
          />
          <mask
            id="mask1_2701_36645"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="7"
            y="4"
            width="10"
            height="10">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 13.6655C14.402 13.6655 16.3493 11.5976 16.3493 9.04664C16.3493 6.49569 14.402 4.42773 12 4.42773C9.59794 4.42773 7.6507 6.49569 7.6507 9.04664C7.6507 11.5976 9.59794 13.6655 12 13.6655Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_2701_36645)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.5014 9.40109C16.5014 9.40109 16.2572 7.22313 14.4492 7.10489C12.6413 6.98666 12.1538 8.70208 12.0494 9.15656C11.9451 9.61104 11.681 10.8234 9.77741 10.8234C7.8738 10.8234 7.70209 7.7406 7.70209 7.7406V4.10547H16.5014V9.40109Z"
              fill="#E31D1C"
            />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.4745 1.53906L6.16073 2.15971L2.98053 5.87364L2.29431 5.25299L5.4745 1.53906ZM6.60627 2.54333L7.29249 3.16398L4.22629 6.8241L3.54007 6.20346L6.60627 2.54333ZM8.419 4.18076L7.73278 3.56012L4.65807 7.24802L5.34429 7.86866L8.419 4.18076Z"
            fill="#272727"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.0228 1.2793L18.3365 1.89762L19.527 3.29474L20.2134 2.67642L19.0228 1.2793ZM21.139 3.84937L20.4527 4.46769L21.6432 5.86481L22.3296 5.24649L21.139 3.84937ZM16.071 3.90995L16.7574 3.29163L17.9479 4.68875L17.2616 5.30707L16.071 3.90995ZM18.8736 5.86169L18.1872 6.48002L19.3778 7.87714L20.0641 7.25882L18.8736 5.86169ZM17.2467 2.87375L17.933 2.25543L21.247 6.29108L20.5606 6.9094L17.2467 2.87375Z"
            fill="#272727"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.5412 10.6832L18.8491 10.0625L17.6485 11.4651L18.3406 12.0858L19.5412 10.6832ZM17.5227 13.1515L16.8306 12.5308L15.63 13.9333L16.3221 14.5541L17.5227 13.1515ZM21.0349 12.0256L21.727 12.6463L20.5264 14.0489L19.8343 13.4282L21.0349 12.0256ZM19.8073 15.1717L19.1151 14.551L17.9145 15.9535L18.6067 16.5743L19.8073 15.1717ZM17.9749 13.4844L18.6671 14.1051L17.4139 15.6028L16.7217 14.9821L17.9749 13.4844ZM20.7231 11.6096L20.031 10.9888L18.7778 12.4865L19.4699 13.1073L20.7231 11.6096Z"
            fill="#272727"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.80496 11.1678L5.49136 10.5488L8.55481 14.0591L7.86841 14.6781L4.80496 11.1678ZM5.51952 14.2381L6.20593 13.6191L7.49991 15.0408L6.8135 15.6598L5.51952 14.2381ZM3.23207 12.5185L2.54566 13.1375L5.62501 16.695L6.31142 16.076L3.23207 12.5185ZM3.72048 12.1145L4.40689 11.4955L5.52864 12.8109L4.84224 13.4299L3.72048 12.1145Z"
            fill="#272727"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2701_36645">
          <rect width="24" height="18" rx="3" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ChinaIcon = () => {
  return (
    <svg
      className="rounded-[2px]"
      width="16"
      height="12"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H24V18H0V0Z"
        fill="#E31D1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2618 3.41208L10.5042 3.86945L10.677 2.97693L10.0461 2.30897L10.9004 2.27285L11.2618 1.43945L11.6232 2.27285H12.4761L11.8466 2.97693L12.0361 3.86945L11.2618 3.41208Z"
        fill="#FECA00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.26315 7.20625L3.10253 8.36945L3.59535 6.09958L1.79608 4.40081L4.2324 4.30895L5.26315 2.18945L6.29391 4.30895H8.72608L6.93095 6.09958L7.47139 8.36945L5.26315 7.20625Z"
        fill="#FECA00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7618 6.41208L12.0042 6.86945L12.177 5.97693L11.5461 5.30897L12.4004 5.27285L12.7618 4.43945L13.1232 5.27285H13.9761L13.3466 5.97693L13.5361 6.86945L12.7618 6.41208Z"
        fill="#FECA00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0118 9.41208L11.2542 9.86945L11.427 8.97693L10.7961 8.30897L11.6504 8.27285L12.0118 7.43945L12.3732 8.27285H13.2261L12.5966 8.97693L12.7861 9.86945L12.0118 9.41208Z"
        fill="#FECA00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.76181 11.6621L9.00419 12.1195L9.177 11.2269L8.54608 10.559L9.40037 10.5228L9.76181 9.68945L10.1232 10.5228H10.9761L10.3466 11.2269L10.5361 12.1195L9.76181 11.6621Z"
        fill="#FECA00"
      />
    </svg>
  );
};

export const JapanIcon = () => {
  return (
    <svg
      className="rounded-[2px]"
      width="16"
      height="12"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2701_36694)">
        <rect width="24" height="18" rx="3" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V18H24V0H0Z"
          fill="#EBEDEE"
        />
        <mask
          id="mask0_2701_36694"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="18">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V18H24V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_2701_36694)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 14.625C15.1066 14.625 17.625 12.1066 17.625 9C17.625 5.8934 15.1066 3.375 12 3.375C8.8934 3.375 6.375 5.8934 6.375 9C6.375 12.1066 8.8934 14.625 12 14.625Z"
            fill="#E31D1C"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2701_36694">
          <rect width="24" height="18" rx="3" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
